import type { DocumentDeleteOptions } from '@/types/document';

export const getDeleteAttachmentCount = <T extends { attachments?: unknown[] }>(
  rows: T[],
): number => rows.reduce((count, row) => count + (row.attachments?.length ?? 0), 0);

export const buildDeleteQueryString = (
  options?: DocumentDeleteOptions & { recursive?: boolean },
): string => {
  const params = new URLSearchParams();

  if (options?.recursive) params.set('recursive', 'true');
  if (options?.force) params.set('force', 'true');
  if (options?.deleteAttachments) params.set('delete_attachments', 'true');

  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};
